import {
  RequestHookParams,
  useRequest,
  ResponseWithMeta,
} from 'src/shared/api';
import { RequestByLimitOffset } from 'src/shared/api/request';
import { apiRoutesMap } from 'src/shared/config';
import { FuturePrice } from './model';

export const useGetFuturePrices = (
  params: RequestHookParams<RequestByLimitOffset>,
) =>
  useRequest<ResponseWithMeta<FuturePrice[]>>(
    apiRoutesMap.futurePrices.getRoute(),
    params,
  );

export const useGetFuturePrice = (params: RequestHookParams<{ id: string }>) =>
  useRequest<ResponseWithMeta<FuturePrice>>(
    apiRoutesMap.futurePrice.getRoute(params.variables.id),
    params,
  );
